<template>
  <el-checkbox-button
    ref="checkbox"
    v-bind="$attrs"
    @click.native="handleClick"
  >
    <slot />
  </el-checkbox-button>
</template>

<script>
import ElCheckboxButton from 'vue-xpc/src/element-ui/packages/checkbox/src/checkbox-button.vue';

export default {
  name: 'RtCheckboxButton',
  components: {
    ElCheckboxButton
  },
  methods: {
    handleClick () {
      this.$refs.checkbox.focus = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtCheckboxButton.vue?417ec9b1